import { AvatarGroup, Button, Card, CardContent, Menu, MenuItem } from '@mui/material'
import moment from 'moment'
import react, { useContext, useEffect, useState } from 'react'
import './eventList.scss'
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import UserAvatar from '../../../../utils/Avatar/Avatar';
import DeleteDialog from '../DeleteEventModal/deleteEventModal';
import location from "../../../../assets/location.jpg"
import NavigationRoundedIcon from '@mui/icons-material/NavigationRounded';
import meeting from '../../../../assets/meeting.jpg'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks/hooks';
import EventModal from './eventModal/eventModal';
import { StudentActions } from '../../../../store/StudentAction';
import EditEVentModal from './editEventModal/editEventModal';
import EditPlacementVisitModal from './editPlacementVisitModal/editPlacementVisitModal';


const EventCard = (props: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const userDetails = useAppSelector((state: any) => state.user.user)
    const open = Boolean(anchorEl);
    const dispatch = useAppDispatch()
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const switchCard = () => {
        switch (props.event.EventType) {
            case 'TM':
                return (
                    <Card className='eventCard meetingCard mt-3'>
                        <CardContent className='p-0'>
                            <div className='flex flex-row'>
                                <div style={{
                                    backgroundImage: `url(${meeting})`,
                                }} className="image">
                                    <div className='align-items-center flex flex-column textContainer'>
                                        <p className='font-weight-700 textShadow m-0'>{moment(props.event.details.From).format("D")}</p>
                                        <p className='font-weight-700 textShadow m-0'>{moment(props.event.details.From).format("MMM")}</p>
                                    </div>

                                </div>
                                <div className='align-items-baseline flex flex-column justify-content-between w-100'>
                                    <div className='align-items-center flex justify-content-between mb-1 w-100'>
                                        <p className='font-weight-700 eventCardTitle m-0'>{props.event.details.title}</p>
                                        {
                                            userDetails.isAdmin && <>
                                                <IconButton
                                                    id="icon-button"
                                                    size='small'
                                                    onClick={handleClick}
                                                >
                                                    <MoreVertIcon fontSize='small' />
                                                </IconButton>
                                                <Menu
                                                    id="basic-menu"
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    onClose={handleClose}
                                                    MenuListProps={{
                                                        'aria-labelledby': 'basic-button',
                                                    }}
                                                >
                                                    <EditEVentModal event={props.event} editEventComplete={() => {
                                                        handleClose()
                                                    }}></EditEVentModal>
                                                    <DeleteDialog event={props.event}></DeleteDialog>
                                                </Menu>
                                            </>
                                        }

                                    </div>
                                    <div className='align-items-baseline align-items-stretch flex flex-row justify-content-between w-100'>
                                        <AvatarGroup className='mx-2'>
                                            {
                                                props.event.details.participants && props.event.details.participants.map((elm: any) => {
                                                    if (props.event.details.acceptedParticipants.includes(elm.Student_ID ? elm.Student_ID : elm.Id)) {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={1} badge={true} />
                                                        )
                                                    }
                                                    else if (props.event.details.rejectedParticipants.includes(elm.Student_ID ? elm.Student_ID : elm.Id)) {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={0} badge={true} />
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.first_name} ${elm.last_name}`} status={-1} badge={true} />
                                                        )
                                                    }


                                                })
                                            }
                                        </AvatarGroup>
                                        <EventModal event={{ ...props.event }}></EventModal>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                )
            case 'PV':
                return (
                    <Card className='eventCard meetingCard mt-3'>
                        <CardContent className='p-0'>
                            <div className='flex flex-row'>
                                <div style={{
                                    backgroundImage: `url(${location})`,
                                }} className="image">
                                    <div className='align-items-center flex flex-column textContainer h-100'>
                                        <p className='font-weight-700 textShadow m-0'>{moment(props.event.details.scheduleDate).format("D")}</p>
                                        <p className='font-weight-700 textShadow m-0'>{moment(props.event.details.scheduleDate).format("MMM")}</p>
                                    </div>

                                </div>
                                <div className='align-items-baseline flex flex-column justify-content-between w-100'>
                                    <div className='align-items-center flex justify-content-between mb-1 w-100'>
                                        <p className='font-weight-700 eventCardTitle m-0'>Placement Visit</p>
                                        {
                                            userDetails.isAdmin && <>
                                                <IconButton
                                                    id="icon-button"
                                                    size='small'
                                                    onClick={handleClick}
                                                >
                                                    <MoreVertIcon fontSize='small' />
                                                </IconButton>

                                                <Menu
                                                    id="basic-menu"
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    onClose={handleClose}
                                                    MenuListProps={{
                                                        'aria-labelledby': 'basic-button',
                                                    }}
                                                >
                                                    <EditPlacementVisitModal event={props.event} editEventComplete={() => {
                                                        handleClose()
                                                    }}></EditPlacementVisitModal>
                                                    <DeleteDialog event={props.event}></DeleteDialog>
                                                </Menu>
                                            </>
                                        }
                                    </div>
                                    <div className='align-items-baseline align-items-stretch flex flex-row justify-content-between w-100'>
                                        <AvatarGroup className='mx-2'>
                                            {
                                                props.event.details.participants && props.event.details.participants.map((elm: any) => {
                                                    if (props.event.details.acceptedParticipants.includes(elm.user.Student_ID ? elm.user.Student_ID : elm.user.Id)) {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={1} badge={true} />
                                                        )
                                                    }
                                                    else if (props.event.details.rejectedParticipants.includes(elm.user.Student_ID ? elm.user.Student_ID : elm.user.Id)) {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={0} badge={true} />
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <UserAvatar key={elm._id} name={`${elm.user.first_name} ${elm.user.last_name}`} status={-1} badge={true} />
                                                        )
                                                    }
                                                })
                                            }
                                        </AvatarGroup>
                                        <EventModal event={{ ...props.event }}></EventModal>
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                )
        }
    }
    return (
        <>
            {switchCard()}
        </>
    )

}

const EventList = (props: any) => {
    const groupedEvents = props.events.reduce((eventGroup: any, elm: any) => {
        if (elm.EventType === "TM") {
            const eventDate = elm.details.From.split('T')[0];
            if (!eventGroup[eventDate]) {
                eventGroup[eventDate] = [];
            }
            eventGroup[eventDate].push(elm);
        }
        else if (elm.EventType === "PV") {
            const eventDate = elm.details.scheduleDate.split('T')[0];
            if (!eventGroup[eventDate]) {
                eventGroup[eventDate] = [];
            }
            eventGroup[eventDate].push(elm);
        }

        return eventGroup;
    }, {});

    const GroupedEventDisplay = (events: any) => {
        let date = new Date()
        const previous = new Date(date.getTime());
        previous.setDate(date.getDate() - 1);
        return Object.keys(events).sort((a, b) => a > b ? 1 : -1).filter(elm => new Date(elm) >= previous).slice(0, 3).map((elm: any, index: any) => {
            return (
                <div className='p-2' key={index}>
                    {
                        Object.keys(events[elm]).length > 0 ?
                            <>
                                {
                                    events[elm].map((event: any, index: any) => {
                                        return (
                                            <EventCard key={index} event={event}></EventCard>
                                        )
                                    })
                                }
                            </> :
                            null
                    }

                </div>
            )
        })
    }
    return (
        <div className='p-4 p-0Mob'>
            <h4 className='cardTitle m-0'>Upcoming Events</h4>
            {
                props.events.length > 0 ?
                    <>
                        {
                            GroupedEventDisplay(groupedEvents)
                        }</> :
                    <div className="align-items-center flex h-100 justify-content-center w-100">
                        <p className="subTitle gray-color body-p m-0 ">No Events Found</p>
                    </div>
            }
        </div>


    )

}
export default EventList